import { WSForm, WSInputDate } from "@wingspanhq/fe-component-library";
import { AttributeDefinition } from "@wingspanhq/wingspan-api-sdk";

type Props = {
  definition: AttributeDefinition;
  disabled?: boolean;
};

export const FieldDatetime: React.FC<Props> = props => {
  return (
    <WSForm.Field
      name={props.definition.key}
      component={WSInputDate}
      componentProps={{
        label: props.definition.name,
        helperText: props.definition.description,
        required: props.definition.isRequired,
        showTime: true,
        disabled: props.disabled
      }}
    />
  );
};
